import { render, staticRenderFns } from "./mng_health.vue?vue&type=template&id=12c35a70&scoped=true&v-once=true"
import script from "./mng_health.vue?vue&type=script&lang=js"
export * from "./mng_health.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c35a70",
  null
  
)

export default component.exports